/* eslint-disable react-hooks/exhaustive-deps */
import ReplayIcon from '@mui/icons-material/Replay';
import {
  Button,
  Grid,
  IconButton,
  Paper,
  Stack,
  Typography
} from '@mui/material';
import { useJsApiLoader } from '@react-google-maps/api';
import { get, isEmpty, map } from "lodash";
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from 'react-router-dom';
import { Speed, LocalGasStation } from '@mui/icons-material';

import Alert from "../../../components/form/Alert";
import DragAndDropComponent from '../../../components/form/DragAndDrop';
import Notification from "../../../components/form/Notification";
import DeliveryPointsModal from "./DeliveryPointsModal";
import DeliveryPointDateModal from "./DeliveryPointDateModal";
import DeliveryPointStatusModal from "./DeliveryPointStatusModal";
import Skeleton from "../../../components/form/Skeleton";
import FilesModalDeliveryPoint from "./FilesModalDeliveryPoint";
import AddIcon from '@mui/icons-material/Add';
import Warning from '@mui/icons-material/Warning';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import { Download } from '@mui/icons-material';


import { calculateKilometers, roundPrice } from '../../../config/hook/calculateKilometer';
import { getDeliveryPointRoute } from "../../../store/transactions/thunk/deliveyPointRoute/getAll";
import { postRouteDeliveryPoint } from "../../../store/transactions/thunk/route/postDeliveyPoint";
import { getRouteId } from "../../../store/transactions/thunk/route/getId";
import { useCanView } from "../../../config/hook/UserPermissions";
import { postNewDeliveryPointRoute } from "../../../store/transactions/thunk/route/postDeliveryPointTemplate";

const REACT_APP_GOOGLE_MAP_API_KEY = process.env.REACT_APP_GOOGLE_MAP_API_KEY;

const DeliveryPoints = ({ setBtns, isEdit }) => {
  const [__] = useTranslation("route");
  const [__o] = useTranslation("order");
  const [km, setKm] = useState(0);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isMapRouteReady, setIsMapRouteReady] = useState(false);
  const inputFileRef = useRef(null); // Ref para el input

  const fuelCost = useRef({ kiloXGallon: 0, priceFuel: 0, kms: 0, gal: 0, cost: 0 });
  const positionsRef = useRef([]);
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: REACT_APP_GOOGLE_MAP_API_KEY
  });

  const { id } = useParams();
  const idRoute = Number(id);
  const dispatch = useDispatch();
  const isFirstRender = useRef(true);
  const canView = useCanView();

  const [showNoti, setShowNoti] = useState({ open: false, msg: "", variant: "error", action: "post" })
  const [alert, setAlert] = useState({ open: false, title: "", subtitle: "", type: "" })
  const [openModal, setOpenModal] = useState(false);
  const [openModalDetail, setOpenModalDetail] = useState(false);
  const [openModalstatus, setOpenModalStatus] = useState(false);
  const [openModalImage, setOpenModalImage] = useState(false);
  const [change, setChange] = useState(false);

  const [openQuestion, setOpenQuestion] = useState(null);
  const [openQuestionLiq, setOpenQuestionLiq] = useState(null);
  const [selectedPoint, setSelectedPoint] = useState("");
  
  const current = useSelector(state => state.transactions.route.detail);
  const put = useSelector(state => state.transactions.route.putOrder);
  const post = useSelector(state => state.transactions.route.postOrder);
  const putLiquidateOrder = useSelector(state => state.transactions.route.putLiquidateOrder);
  const success = useSelector(state => state.transactions.route.postDeliveryPoint)
  const [deliveryPoints, setDeliveryPoints] = useState([])
  const [newPoints, setNewPoints] = useState([]);
  const postDeliveryPoint = useSelector(state => state.transactions.route.postDeliveryPoint);
  const postDeliveryPointTemplate = useSelector(state => state.transactions.route.postDeliveryPointRouteTemplate);
  
   const getDataRoute = () => {
    dispatch(getRouteId(id))
   }

   useEffect(() => {
    setDeliveryPoints(get(current, "data.routeDeliveryPoints"))
   },[current])
   
   // validate 
   const [positions, setPositions] = useState([]);

  const reload = () => {
     getDataRoute();
  }

  useEffect(() => {
    if(get(success,"isSuccess", false)) { reload(); setShowNoti({ open: true, msg: "", variant: "success", action: "put" });}
    if(get(postDeliveryPoint, "isSuccess", false)) { reload(); setShowNoti({ open: true, msg: "", variant: "success", action: "put" });}
    if (get(postDeliveryPoint, "isReject", false)) { setError(get(postDeliveryPoint, "error", {}), "post") }
    if (get(postDeliveryPointTemplate, "isSuccess", false)) { reload(); setShowNoti({ open: true, msg: "", variant: "success", action: "put" }); }
    if (get(postDeliveryPointTemplate, "isReject", false)) { setError(get(postDeliveryPointTemplate, "error", {}), "put") }
  }, [success, postDeliveryPoint, postDeliveryPointTemplate])

  useEffect(() => {
    if (newPoints.length === 1) {
      setDeliveryPoints((prev) => [...prev, ...newPoints]);
      setIsMapRouteReady(true);
      setNewPoints([]);
        // console.log("Nuevo punto")
    } else if (positions.length > 0 && change) {
        // console.log("Cambio o eliminacion");
      getMapRoutes();
    } else if (get(current, "data.kilometersEstimate") === 0) {
      getMapRoutes();
      // console.log("inicial")
    } else {
      fuelCost.current = { kms: (get(current, "data.kilometersEstimate"))?.toFixed(1) || "0.0", cost: get(current, "data.fuelCost")?.toFixed(2) || "0.00" }
    }
  }, [positions, newPoints])

  useEffect(() => {
    if (isMapRouteReady && deliveryPoints.length > 1 ) {
      getMapRoutes(); 
      setIsMapRouteReady(false);  
    }
  }, [deliveryPoints, isMapRouteReady]);

  const onSubmit = () => {
    if (fuelCost.current.kms) {
      const body = {
        idRoute: Number(id),
        kilometersEstimate: fuelCost.current.kms, 
        fuelCost: 0,
        fuelGallons: 0,
        deliveryPoints: positionsRef.current.map(({ ordering, idDeliveryPoint, canDelete, deliveryDate, statusId, comment, deliveryRealDate }) => ({ ordering, idDeliveryPoint, canDelete, deliveryDate, statusId, comment: comment ?? "Se agrego Punto", deliveryRealDate: deliveryRealDate ?? deliveryDate}))
      };
       dispatch(postRouteDeliveryPoint(body));
       setChange(false)
    } 
  };

  
  const HandleEditTime = (item) => {
    setSelectedPoint(item);
    setOpenModalDetail(true);
  }
  
  const HandleEditstatus = (item) => {
    setSelectedPoint(item);
    setOpenModalStatus(true);
  }

  const HandleEditImage = (item) => {
    setSelectedPoint(item);
    setOpenModalImage(true)
  }

  const handleFileUpload = (event) => {
    const file = event.target.files[0]; // Obtener solo el primer archivo

    if (file) {
      const formData = new FormData();
      formData.append("File", file);
      dispatch(postNewDeliveryPointRoute({formData, idRoute}));  
    }
  };
  
  const handleUpdatePointDetail = (deliveryPoint) => {
    
    const { idDeliveryPoint, deliveryDate } = deliveryPoint;
    
    positionsRef.current = positionsRef.current.map(point => {
      if (point.idDeliveryPoint === idDeliveryPoint) {
        // Retorna una nueva versión del objeto con la fecha actualizada
        return {
          ...point,
          deliveryDate: deliveryDate // Actualiza la fecha con la nueva fecha del objeto deliveryPoint
        };
      }
      return point; // Retorna el objeto sin cambios si no coincide
    });
    onSubmit();
  };
  
  const handleUpdatePointStatus = (deliveryPoint) => {
    
    const { idDeliveryPoint, statusId, comment, deliveryRealDate } = deliveryPoint;
    
    positionsRef.current = positionsRef.current.map(point => {
      if (point.idDeliveryPoint === idDeliveryPoint) {
        return {
          ...point,
          statusId: statusId, 
          comment: comment,
          deliveryRealDate: deliveryRealDate
        };
      }
      return point;
    });
    onSubmit();
  };
  
  /*********************************************************** FUNCIONDES DEL DRAG AND DROPX *************************************************************************/
  const getMapRoutes = async () => {
    if (!isSubmitting) {
      setIsSubmitting(true);  
      
      if (deliveryPoints.length > 0) {
        let origin = deliveryPoints[0];
        let destination = deliveryPoints[deliveryPoints.length - 1];
        let _waypoints = deliveryPoints.slice(1, -1);
        let waypoints = _waypoints.length > 0 ? _waypoints.map(({ latitude: lat, longitude: lng }) => {
          let _lat = Number(lat);
          let _lng = Number(lng);
          return {
            location: { lat: _lat, lng: _lng },
            stopover: true,  // Mantiene los waypoints con parada
          };
        }) : [];
        const kms = await calculateKilometers(origin, destination, waypoints);
        const retorno = await calculateKilometers(destination, origin);
        let { kiloXGallon, priceFuel } = current.data;
        let totalKm = Number(retorno) + Number(kms);
        let gal = totalKm / kiloXGallon;
        let cost = gal * priceFuel;
  
        fuelCost.current = { kiloXGallon, priceFuel, kms: totalKm, gal, cost: roundPrice(cost.toFixed(2)) };
  
        setKm(totalKm);  
        await onSubmit();  
      }
      setIsSubmitting(false);  
    }
  };  

  const moveItem = (dragIndex, hoverIndex) => {
    const updatedDeliveryPoints = [...positions];
  
    // Guardamos el elemento que se mueve
    const [removed] = updatedDeliveryPoints.splice(dragIndex, 1);
    updatedDeliveryPoints.splice(hoverIndex, 0, removed);
  
    // Actualizamos el ordering de cada elemento según su nueva posición
    const reorderedPoints = updatedDeliveryPoints.map((point, index) => ({
      ...point,
      ordering: index + 1, // Actualiza el ordering comenzando desde 1
      
    }));
  
    // Guardamos el nuevo estado
    setDeliveryPoints(reorderedPoints);
    setChange(true)
  };
  
  const handleDelete = (idDeliveryPoint) => {
    const updatedPoints = positions.filter(item => item.idDeliveryPoint !== idDeliveryPoint);
    // Actualiza el estado local
    setDeliveryPoints(updatedPoints);
    setChange(true)
  };

  /***********************************************************************************************************************************/

  const closeAlert = () => {
    setAlert({ open: false, title: "", subtitle: "", type: "", btn: "" })
    setOpenQuestion(false)
    setOpenQuestionLiq(false)
  }

  const setError = (err, action) => {
    if (!isEmpty(err) && !!get(err, "Message", "")) {
      setAlert({
        open: true,
        title: get(err, "Message", ""),
        subtitle: (<ul>{map(get(err, "ValidationError", []), (item) => <li>{`• ${item}`}</li>)}</ul>),
        type: "error",
        btn: __(`${module}.actions.close`),
        func: closeAlert
      })
    } else {
      setAlert({
        open: true,
        type: "error",
        title: "Uno o más errores de validación han ocurrido.",
        subtitle: (<li>{` ${get(err, "ErrorMessage")}`}</li>),
        btn: __(`${module}.actions.close`),
        func: closeAlert
      })
    }

  }

  useEffect(() => {
    if (get(put, "isSuccess", false)) { setOpenModal(false); setOpenQuestion(false); reload(); setShowNoti({ open: true, msg: "", variant: "success", action: "put" }) }
    if (get(put, "isReject", false)) { setError(get(put, "error", {}), "put") }
    if (get(post, "isSuccess", false)) { setOpenModal(false); reload(); setShowNoti({ open: true, msg: "", variant: "success", action: "put" }) }
    if (get(post, "isReject", false)) { setError(get(post, "error", {}), "put") }
    if (get(putLiquidateOrder, "isSuccess", false)) { setOpenModal(false); setOpenQuestionLiq(false); reload(); setShowNoti({ open: true, msg: "", variant: "success", action: "put" }) }
    if (get(putLiquidateOrder, "isReject", false)) { setError(get(putLiquidateOrder, "error", {}), "put") }
  }, [put, post])


  useEffect(() => {
    setBtns(
      <Stack direction="row" spacing={1} justifyContent="flex-end" className="mr-4">
        
        <Grid item xs="auto" justifyContent="flex-end" display="flex">
            <a href={`/PlantillaPuntosEntrega.csv`} download>
                <Button
                variant="contained"
                color="warning" 
                startIcon={<Download/>} 
                >
                Descargar CSV
                </Button>
            </a>
        </Grid>

        {isEdit && ![7, 8, 5, 9].includes(get(current, "data.idRouteStatus")) && (
          <>
            <Button
              className='w-[100px] min-w-[100px]'
              variant="contained"
              sx={{ backgroundColor: '#00BFFF', color: 'white' }}
              startIcon={<ImportExportIcon />}
              onClick={() => {
                if (canView("TRANSACCIONES/RUTAS/PUNTOS DE ENTREGA/IMPORTAR", "add")) {
                  inputFileRef.current.click()
                } else {
                  setAlert({
                    open: true,
                    title: "Permiso Denegado.",
                    subtitle: (<ul>• No tienes permiso para importar nuevos puntos de entrega a la ruta.</ul>),
                    type: "error",
                    btn: __(`${module}.actions.close`),
                    func: closeAlert
                  })
                }
              }}
            >
              Importar
            </Button>
  
            <input
              type="file"
              accept=".csv"
              ref={inputFileRef}
              hidden
              onChange={handleFileUpload}
            />
            <Button
              className='w-[100px] min-w-[100px]'
              startIcon={<AddIcon />}
              variant="contained"
              color="secondary"
              disabled={current.data?.routeDeliveryPoints?.length >= 25}
              onClick={() => {
                if (canView("TRANSACCIONES/RUTAS/PUNTOS DE ENTREGA", "add")) {
                  setOpenModal(true)
                } else {
                  setAlert({
                    open: true,
                    title: "Permiso Denegado.",
                    subtitle: (<ul>• No tienes permiso para agregar nuevos puntos de entrega a la ruta.</ul>),
                    type: "error",
                    btn: __(`${module}.actions.close`),
                    func: closeAlert
                  })
                }
              }}
            >
              {__(`toolbar.btn`)}
            </Button>
  
          </>
        )}
  
        {/* Reload */}
        <IconButton title={__(`toolbar.reload`)} onClick={reload}>
          <ReplayIcon sx={{ transform: "scaleX(-1) rotate(-45deg)" }} />
        </IconButton>
  
      </Stack>
    )
  }, [isEdit, current])
  

  return (
    <div>
      {get(success, "isLoading") || get(postDeliveryPoint, "isLoading")
      ? (
        <Skeleton />
        ) : (
          <DragAndDropComponent
            points={deliveryPoints}
            newPoints={positions}
            callBackPoint={(res) => {
              positionsRef.current = res;
              setPositions(res);
            }}
            onEditTime={HandleEditTime}
            onEditStatus={HandleEditstatus}
            onEditImage={HandleEditImage}
            text={(
              <>
              {current.data?.routeDeliveryPoints?.length >= 25 && (
                <Stack direction="row"  spacing={1} alignItems="center" justifyContent="center" style={{ marginTop: "10px" }}>
                  <Warning color="error" />
                  <Typography component="p" variant="h6" color="error">
                    Se ha llegado al límite de puntos de entrega en la ruta (Capacidad máxima: 25 puntos).
                  </Typography>
                </Stack>
                )}
              <Stack className='p-4' direction="row" spacing={2} justifyContent="space-between">
                  <Typography component="h4" variant="h4">
                     <Speed /> {fuelCost.current.kms} Km
                  </Typography>
                  <Typography component="h4" variant="h4">
                      <LocalGasStation/> ${fuelCost.current.cost} 
                  </Typography> 
              </Stack>
              </>
            )}
            callbackChange = {(state) => {
              setChange(state);
            }}
            moveItem={moveItem}  // Pasas la función moveItem
            handleDelete={handleDelete} 
            stateRoute={get(current, "data.idRouteStatus")}
          />
        )}
      <DeliveryPointsModal
        __={__}
        open={openModal}
        close={() => setOpenModal(false)}
        showNoti={showNoti}
        setShowNoti={setShowNoti}
        callbackNewPoints = {(newPoint) => {
          setNewPoints(newPoint)
        }}
        alert={alert}
        setAlert={setAlert}
        setError={setError}
        reload={reload}
        points = {deliveryPoints}
      />
      <DeliveryPointDateModal
       __={__}
       open={openModalDetail}
       close={() => setOpenModalDetail(false)}
       selected={selectedPoint}
       onUpdate={handleUpdatePointDetail}
      />
      <DeliveryPointStatusModal 
        __={__}
        open={openModalstatus}
        close={() => setOpenModalStatus(false)}
        selected={selectedPoint}
        onUpdate={handleUpdatePointStatus}
      />
      <FilesModalDeliveryPoint 
        __={__}
        open={openModalImage}
        close={() => setOpenModalImage(false)}
        selected={selectedPoint}
      />
      <Notification __={__} showNoti={showNoti} setShowNoti={setShowNoti} />
      <Alert
        title={get(alert, "title")}
        subtitle={get(alert, "subtitle")}
        btn1={{ func: get(alert, "func") }}
        btn2={{}}
        type={get(alert, "type")}
        openAlert={get(alert, "open")}
        closeAlert={closeAlert}
      />
    </div >
  )
}

export default DeliveryPoints;
